<template>
  <div v-if="loggedAndGotRoles">
    <AppNavigation :items="items"></AppNavigation>
    <AppToolbar></AppToolbar>
  </div>
</template>

<script>
  import AppNavigation from '@/components/AppNavigation'
  import AppToolbar from '@/components/AppToolbar'

  export default {
    name: 'AppMainMenu',
    components: { AppNavigation, AppToolbar },
    data () {
      return {
        items: [
          { icon: 'contact_phone', text: 'New Case', id: 'NewLeads', url: '/new-case' },
          { icon: 'accessibility_new', text: 'Select Shifting Crew', id: 'AssignCrewAndTiming', url: 'assign-crew-and-timing' },
          // { icon: 'accessibility_new', text: 'Assign Crew and Timing', id: 'NewLeads', url: '/assign-crew-and-timing' },
          { icon: 'schedule', text: 'Appointment Schedule', id: 'AppointmentSchedule', url: '/appointment-schedule' },
          // { icon: 'create', text: 'Onboard Client', id: 'OnboardClient', url: '/onboard-client' },
          // { icon: 'work', text: 'Select Plan & Vendors', id: 'Cases', url: '/cases' },
          // { icon: 'account_box', text: 'Assign Crew and Timing', id: 'Bookings', url: '/bookings' },
          { icon: 'check_circle', text: 'Event Checklist', id: 'EventChecklist', url: '/event-checklist' },
          { icon: 'supervisor_account', text: 'Select Crew for Tasking', id: 'SelectCrew', url: '/event-crew' },
          { icon: 'check_circle_outline', text: 'Closing Event', id: 'Cases', url: '/cases' },
          { icon: 'account_balance_wallet', text: 'Billing', id: 'Billing', url: '/billing' },
          { icon: 'zoom_in', text: 'Inventory Report', id: 'InventoryReport', url: '/inventory-report' },
          { icon: 'calendar_today', text: 'Reminders', id: 'Reminders', url: '/reminders' },
          { icon: 'insert_chart_outlined', text: 'Commissions Reports', id: 'Analytics', url: '/commissions-reports' },
          { icon: 'insert_chart_outlined', text: 'Sales Report', id: 'SalesReport', url: '/sales-report' },
          { icon: 'insert_chart_outlined', text: 'Inventory Report', id: 'InventoryReport', url: '/inventory-report' },
          { icon: 'settings',
            text: 'Settings',
            iconalt: 'settings',
            id: 'Settings',
            children: [
              // { text: 'Inventories', id: 'Inventories', url: '/inventories' },
              // { text: 'Services', id: 'Services', url: '/services' },
              { text: 'Plans', id: 'Plans', url: '/plans' },
              { text: 'Users', id: 'Users', url: '/users' },
              { text: 'Clients', id: 'Clients', url: '/clients' },
              { text: 'Roles', id: 'Roles', url: '/roles' },
              { text: 'Notifications', id: 'Notifications', url: '/notifications' },
              { text: 'Products', id: 'Products', url: '/products' },
              { text: 'General', id: 'Settings', url: '/settings' },
              { text: 'Test Lunar', id: 'Settings', url: '/test' }
              // { text: 'Whatsapp Notifications', id: 'WhatsappNotifications', url: '/notifications/whatsapp' }
              // { text: 'SMS Notifications', id: 'SMSNotifications', url: '/notifications/sms' },
              // { text: 'PDF Templates', id: 'PDFTemplates', url: '/templates' }
            ]
          }
          // { icon: 'chevron_right', text: 'Forms', url: '/forms' },
        ]
      }
    },
    computed: {
      loggedAndGotRoles () {
        if (this.$store.getters.logInStatus === true && this.$store.getters.currentUserRoles.length > 0) {
          return true
        }

        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppMainMenu.vue?7797d3b2